.watch-on-roku {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  border-radius: 999px;
  font-weight: 600;
  line-height: 1;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.watch-on-roku__brand {
  display: inline-flex;
  align-items: center;
  font-weight: 800;
  letter-spacing: 0.6px;
  border-radius: 6px;
  padding: 3px 7px;
  font-size: 0.72em;
}

/* Solid button — used on the public replay page */
.watch-on-roku--button {
  padding: 10px 18px;
  background: linear-gradient(135deg, #c9a227 0%, #e0c98e 100%);
  color: #0a1628;
  box-shadow: 0 2px 8px rgba(201, 162, 39, 0.25);
  font-size: 0.95rem;
}

.watch-on-roku--button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(201, 162, 39, 0.4);
}

.watch-on-roku--button .watch-on-roku__brand {
  background: #0a1628;
  color: #e0c98e;
}

/* Outlined pill — used as a "Now on Roku" badge on the homepage */
.watch-on-roku--badge {
  padding: 7px 14px;
  background: rgba(201, 162, 39, 0.1);
  border: 1px solid rgba(201, 162, 39, 0.45);
  color: #e0c98e;
  font-size: 0.85rem;
}

.watch-on-roku--badge:hover {
  background: rgba(201, 162, 39, 0.18);
  border-color: rgba(201, 162, 39, 0.7);
}

.watch-on-roku--badge .watch-on-roku__brand {
  background: rgba(201, 162, 39, 0.18);
  color: #c9a227;
}
